import React from 'react';
import { FlexGrid, TypographyStyler, UnsafeHTML } from '@honeycomb/ui-core';
import { useGenericRootComponent } from './GenericRootComponent/GenericRootComponent.context';
export function ContentBlock({ contentBlock: { content, centered } }) {
    // `TypographyStyler` is intended to add Honeycomb styling to raw html content based on the active theme.
    // The HTML should be free from any style tags or other styling attributes, as those will take precedence over
    // the automated styling leading to unintended results.
    const { textColor } = useGenericRootComponent();
    return (React.createElement(FlexGrid, { container: true, justifyContent: "center" },
        React.createElement(FlexGrid, { s: 12, m: 10, l: 8 }, content.map((child, index) => {
            const { __typename } = child;
            switch (__typename) {
                case 'HTMLBlock':
                    return (React.createElement(TypographyStyler, { component: "section", ta: centered ? 'center' : undefined, c: textColor, headingColor: "inherit", anchorColor: "inherit", key: index.toString() },
                        React.createElement(UnsafeHTML, null, child.html)));
                default:
                    return React.createElement("div", { key: index.toString() }, __typename);
            }
        }))));
}
